import { EventLogger } from '@/utils/EventLogger'
import { useAuthStore } from '@/modules/auth/stores/authStore'

/**
 * Проверяет валидность JWT accessToken, при истечении пытается обновить
 * Логирует только ошибки через eventLogger
 * @param accessToken - строка JWT
 * @param caller - необязательный идентификатор вызова для логирования
 */
export async function checkTokenValidation(accessToken: string, caller?: string): Promise<boolean> {
  console.log('checkTokenValidation Запущен', caller);
  const authStore = useAuthStore();

  // формируем текст вызова один раз
  const callerText = caller
    ? `Вызов передан из функции - ${caller}`
    : 'Функция вызова не передана в параметре';

  if (!accessToken) {
    EventLogger.error('check_token_validation_invalid', [
      `Отсутствует accessToken, ${callerText}`
    ]);
    return false;
  }

  try {
    const payload = JSON.parse(atob(accessToken.split('.')[1]));
    const exp = payload.exp * 1000;

    if (Date.now() + 5000 < exp) {
      console.log('checkTokenValidation token is valid')
      return true
    }

    // токен истёк, проверяем наличие refreshToken
    const storedRefresh = authStore.refreshToken || ''
    if (!storedRefresh) {
      EventLogger.error('check_token_validation_invalid', [
        `Нет refreshToken для обновления, ${callerText}`
      ]);
      return false;
    }

    // пытаемся обновить токены
    const refreshResult = await authStore.goRefreshToken();
    if (!refreshResult.ok) {
      EventLogger.error('check_token_validation_invalid', [
        refreshResult.error || 'Обновление токена не удалось',
      ]);
    }
    return refreshResult.ok;
  } catch (error: unknown) {
    EventLogger.error('check_token_validation_invalid', [
      `Ошибка при парсинге токена: ${(error as Error).message}`,
      callerText
    ]);
    return false;
  }
}
